import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';

class RelateSessionsModal extends React.Component {
	render() {
		const { isOpen, toggle, sessions, isRelating, isSuccess, submit } = this.props;

		return (
			<FieldModal
				size="small"
				isOpen={isOpen}
				modalTitle="Relate Sessions"
				bodyHeaderText={
					isSuccess ? (
						<span>
							<i className="las la-check-circle" style={{ color: 'var(--success)', marginRight: 6 }} />
							Sessions have been successfully related.
						</span>
					) : (
						<span>
							The following <b>{sessions.length} sessions</b> will be added to each other's related sessions list:
						</span>
					)
				}
				bodyContent={() => (
					<div className="flex column mt-10">
						{sessions.map((s) => (
							<div
								key={s._id}
								className="flex aic p-7"
								style={{ borderBottom: '1px solid var(--border)', gap: 8 }}
							>
								<i className="las la-link grey" />
								<p className="small">{s.name}</p>
								{s.date && (
									<p className="small grey ml-a">{s.date}</p>
								)}
							</div>
						))}
					</div>
				)}
				toggle={toggle}
				actionButtonLabel={isSuccess ? 'Done' : isRelating ? 'Relating...' : 'Relate Sessions'}
				actionButton={isSuccess ? toggle : submit}
				actionButtonDisabled={isRelating}
			/>
		);
	}
}

export default RelateSessionsModal;
